import * as sagaEffects from 'redux-saga/effects';

import handleNewsRequest from './handleNewsRequest';
import handleNewsDetailRequest from './handleNewsDetailRequest';
import handleAddNewsRequest from './handleAddNewsRequest';
import handleUpdateNewsRequest from './handleUpdateNewsRequest';
import handleDeleteNewsRequest from './handleDeleteNewsRequest';

const { all } = sagaEffects;

export default function* () {
    yield all([
        handleNewsRequest(),
        handleNewsDetailRequest(),
        handleAddNewsRequest(),
        handleUpdateNewsRequest(),
        handleDeleteNewsRequest(),
    ]);
}
